import { UIOfferSkill } from 'interfaces/ui/ui-offer-skill';
import { config } from 'utils/config';
import {
  StyledSkillsSoftItem,
  StyledSkillsSoftItemImg,
  StyledSkillsSoftItemTitle
} from './SkillsSoftItem.styled';

type SkillsSoftItemProps = {
  softSkills: UIOfferSkill;
};

const SkillsSoftItem: React.FC<SkillsSoftItemProps> = ({ softSkills }) => (
  <StyledSkillsSoftItem>
    {softSkills.icon && (
      <StyledSkillsSoftItemImg src={softSkills.icon} alt="" />
    )}

    {!softSkills.icon && (
      <StyledSkillsSoftItemImg src={config.defaultSoftSkillIcon} alt="" />
    )}

    <div>
      <StyledSkillsSoftItemTitle>{softSkills.skill}</StyledSkillsSoftItemTitle>
      {softSkills.desc && <p>{softSkills.desc}</p>}
    </div>
  </StyledSkillsSoftItem>
);

export default SkillsSoftItem;
